"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menu = void 0;
var qs = require("qs");
exports.menu = function (axios) {
    return {
        getMenu: function () {
            return axios.get('/menus/all');
        },
        getDisplayableMenu: function (request) {
            return axios.get("/menus?" + qs.stringify(request === null || request === void 0 ? void 0 : request.params));
        }
    };
};
